<ng-container [ngSwitch]="config?.type">
  <ng-container *ngSwitchCase="'icon'">
    <mat-icon
      [inline]="true"
      class="icon-anex"
      [class.ml-12]="position === 'start'"
      [class.ml-8]="position === 'end'"
      [class.mr-8]="position === 'start'"
      [class.mr-12]="position === 'end'"
      [class.material-icons-outlined]="config.outlined"
    >
      {{ config.iconName }}
    </mat-icon>
  </ng-container>
  <ng-container *ngSwitchCase="'text'">
    <span class="t-body-text-regular">{{ config.text }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'template'">
    <ng-container
      [ngTemplateOutlet]="(config.template$ | async) || ([templates] | findTemplate : config.templateName)"
      [ngTemplateOutletContext]="{
        $implicit: {
          config: config,
          control: control,
          templates: templates
        }
      }"
    ></ng-container>
  </ng-container>
</ng-container>
